<template>
  <div
    class="detail-button"
  >
    <van-button
      type="info"
      block
      @click="clickHandler"
    >
      <slot>点击开始拖车</slot>
    </van-button>
  </div>
</template>

<script>
export default {
  name: 'ClickButton',
  data() {
    return {};
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
    },
    // 拖动中
    async clickHandler() {
      await this.$emit('sliderCompleted');
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-button {
  padding: 12px;

  background: #FFFFFF;

  .van-button{
    width: 100%;
    height: 48px;

    text-align: center;

    border-radius: 8px;

    font-family: PingFangSC-Regular;
    font-size: 18px;
    font-weight: 400;

    &.van-button--info{
      color: #FFFFFF;
      border-color: #3399FF;
      background-color: #3399FF;
    }
  }
}

</style>
